<template>

    <div class="equipment-view px-0"
         v-if="equipment.id">

        <heading :title="title" class="heading" tag="equipment-view-title">
            <div class="heading__buttons">
                <router-link class="btn btn-primary btn-icon btn-icon-right"
                             :to="`/equipment/edit/${equipment.id}`"
                             v-if="canEdit">
                    Edit Equipment
                    <b-icon-pencil-square/>
                </router-link>
                <b-btn class="btn btn-primary btn-icon btn-icon-right ml-2"
                       variant="danger"
                       @click="removeItem(equipment)"
                       v-if="canEdit">
                    Delete Equipment
                    <b-icon-trash/>
                </b-btn>
            </div>
        </heading>

        <b-row>
            <b-col cols="12" md="8">
                <equipment-view-attestation :equipment="equipment"
                                            @attested="equipmentAttested()"/>

                <equipment-view-compliance :equipment="equipment"/>

                <equipment-view-compliance-actions :equipment="equipment"
                                                   @updated="compliancePlanUpdated"/>
                <attachment-list class="mt-5"
                                 model-class="Equipment"
                                 model-table="equipment"
                                 help-tag="equipment-upload"
                                 :model-id="equipmentId"
                                 :readOnly="false"/>

            </b-col>
            <b-col cols="12" md="4">
                <equipment-view-details :equipment="equipment"/>

                <template v-if="canMessageOwner">
                    <b-btn @click="showMessageModal()" variant="warning">
                        Message Equipment Owner
                        <b-icon-box-arrow-right/>
                    </b-btn>

                    <message-create-modal :modalId="modalId" :recipient="ownerAdmin"/>
                </template>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="$user.isAdmin() || $user.isSuperAdmin()">
                <equipment-view-logs :equipment="equipment" @noted="noteAdded()"/>
            </b-col>
        </b-row>
    </div>

</template>

<script>
import Vue from 'vue'
import EquipmentFields from '@/models/Equipment'

export default Vue.extend({
    name: 'EquipmentView',
    props: {
        equipmentId: Number,
    },
    data () {
        return {
            title: '',
            equipment: {},
            equipmentFields: EquipmentFields,
        }
    },
    computed: {
        canEdit () {
            return this.$user.isSuperAdmin() || this.$user.isAdmin() ||
                this.$user.isEquipmentOwner() || this.$user.isOwnersRepresentative()
        },
        canMessageOwner () {
            return this.$user.isSuperAdmin() || this.$user.isAdmin()
        },
        modalId () {
            return 'message_modal' + this.hash
        },
        ownerAdmin () {
            return this.equipment ? this.equipment.userOwnerAdmins[0] : null
        }
    },
    methods: {
        equipmentAttested () {
            this.loadEquipment()
        },
        compliancePlanUpdated () {
            this.loadEquipment()
        },
        noteAdded () {
            this.loadEquipment()
        },
        async loadEquipment () {
            const item = await this.$api.getItem(this, 'equipment', this.equipmentId, ['userOwnerAdmins', 'userLogs', 'registrationUserLogs'])
            this.title = `View Equipment: ${item['vehicle_id']}`
            this.equipment = item
        },
        async removeItem (item) {
            if (await this.$bvModal.msgBoxConfirm('Would you like to delete this Equipment? This action cannot be undone.')) {
                await this.$api.deleteItem(this, 'equipment', item)
                await this.$router.push('/equipment/list/')
                this.$toasted.info('Equipment Deleted')
            }
        },
        showMessageModal () {
            this.$bvModal.show(this.modalId)
        },
    },
    created () {
        this.loadEquipment()
    }
})
</script>

<style lang="scss">
// see ViewTable.vue
.view-table {
    .field-value__emission_tier {
        font-weight: bold;
    }
}
</style>
